export const maxPicturesAllowedConst = 1;
